import gatewayApi from "./gatewayAxios";
import { markLoggingOut } from "./serverPush";
import { tokenOfThisTab } from "./thisTabLogin";

// The gateway allows only a few logins at once per user (GWB004 when full). A login's slot is freed when the token
// runs out, or sooner when the user logs out through this call. Best effort by design: logging out must never
// depend on the network, and the page is about to navigate away, so the wait is capped.
const DEFAULT_WAIT_MS = 1500;

export async function logoutFromGateway(waitMs = DEFAULT_WAIT_MS) {
  markLoggingOut();      // the "logout" the gateway pushes back to this very tab must not log it out a second time
  const token = tokenOfThisTab();      // this tab's own login: localStorage holds only the last login of ANY tab (see thisTabLogin.js)
  if (!token) return;

  const call = gatewayApi({
    method: "POST",
    url: `${process.env.REACT_APP_GATEWAY_URL}/auth/logout`,
    headers: { Authorization: `Bearer ${token}` },
  }).catch(() => {});
  const giveUp = new Promise((resolve) => setTimeout(resolve, waitMs));
  await Promise.race([call, giveUp]);
}
